import React from 'react';
import { connect } from 'react-redux';

import Page from '../../../page.jsx';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import withdrawalPropTypes from '../../../withdrawalPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';
import ReceiptLink from '../../../receiptLink.jsx';
import ReviewLink from '../../../review/reviewLink.jsx';
import FeedbackLink, { SELLER_HAPPY } from '../../../feedbackLink.jsx';

const ItemApprovedDetailsWithoutAutomaticWithdrawal = ({
    agreement,
    payment,
}) => (
    <Page heading="Overfør betalingen til din bankkonto">
        <div>
            <p>
                Du har fått {formatOreToKroner(agreement.total)} ({formatOreToKroner(agreement.amount)}{' '}
                for varen og {formatOreToKroner(agreement.freight)} for frakt).
                Pengene står på din{' '}
                <a href={payment.spidWalletUrl}>SPiD Cash-konto</a>.
            </p>

            <div className="r-phl r-ptl">
                <a
                    href={payment.withdrawFlowSpidUrl}
                    className="button r-mbl primary fullwidth"
                >
                    Overfør betalingen til din bankkonto
                </a>

                <ReceiptLink payment={payment} />
                <FeedbackLink type={SELLER_HAPPY} />
            </div>
        </div>
    </Page>
);

ItemApprovedDetailsWithoutAutomaticWithdrawal.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

const ItemApprovedDetailsWithAutomaticWithdrawal = ({ payment, partner }) => (
    <Page heading="Gratulerer, dere er ferdige med handelen!">
        <div>
            <p>
                Vi har overført {formatOreToKroner(payment.amount)} for varen og{' '}
                {formatOreToKroner(payment.freight)} for frakt til din
                bankkonto. Du vil se pengene på konto mellom 1&ndash;3
                virkedager etter godkjenning.
            </p>

            <div className="r-phl r-ptl">
                <ReceiptLink payment={payment} />
                <ReviewLink partner={partner} />
                <FeedbackLink type={SELLER_HAPPY} />
            </div>
        </div>
    </Page>
);

ItemApprovedDetailsWithAutomaticWithdrawal.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

const ItemApprovedDetails = ({ agreement, partner, payment, withdrawal }) =>
    withdrawal ? (
        <ItemApprovedDetailsWithAutomaticWithdrawal
            partner={partner}
            payment={payment}
        />
    ) : (
        <ItemApprovedDetailsWithoutAutomaticWithdrawal
            agreement={agreement}
            payment={payment}
        />
    );

ItemApprovedDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    withdrawal: withdrawalPropTypes,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        payment: state.payment.data,
        partner: state.partner,
        withdrawal: state.withdrawal,
    };
}

export default connect(mapStateToProps)(ItemApprovedDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/statusDetails/itemApprovedDetails.jsx